import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { UIState } from 'data/UIState';
import { NotificationLink } from './NotificationLink';
import { NotificationPlain } from './NotificationPlain';

interface INotificationProps {
	delay:number;
	notification:any;
	user:any;
	handleSetCurrentPage:(page:string)=>void;
}

/**
 * Used:
 * home/Home
 */
@observer
export class Notification extends React.Component<INotificationProps> {
	@observable visible:boolean = false;

	componentDidMount(){
		setTimeout(this.makeVisible, this.props.delay*500+500);
	}
	
	makeVisible = () => {
		this.visible = true;
	}
	
	handleDismissNotification = () => {
		this.visible = false;
		UIState.dismissNotification(this.props.notification);
	}

	render() {		

		const notificationStyle = this.visible ? {top:'0px'} : undefined;
		const notificationWrapperStyle = this.visible ? {maxHeight:'100%'} : undefined;

		return (
			<div className="notification" style={notificationWrapperStyle}>
				<table style={notificationStyle} className={`alert${this.props.notification.action!=''?' link':''}${this.props.notification.dismissed? ' hidden':''}`}>
					<tbody>
						<tr>
							<td className="icon"><div className="icon-circ"><i className={this.props.notification.icon}/></div></td>
							<td>
							{this.props.notification.action || this.props.notification.navPageName ?
								<NotificationLink user={this.props.user} notification={this.props.notification}  handleSetCurrentPage={this.props.handleSetCurrentPage} />
								:
								<NotificationPlain user={this.props.user} notification={this.props.notification} />
							}
							</td>
							<td className="x"><a onClick={this.handleDismissNotification}><i className="icon-close-x" /></a></td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	}
}

